import React from 'react';
import { Tooltip } from 'antd';
import { MobileOutlined, TabletOutlined, DesktopOutlined, ControlOutlined, CarOutlined, CameraOutlined, PlaySquareOutlined, SoundOutlined, ClockCircleOutlined, UsbOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import globalMessages from 'translations/messages';

const analyticsIcons = {
  desktop: DesktopOutlined,
  smartphone: MobileOutlined,
  mobile: MobileOutlined,
  tablet: TabletOutlined,
  'feature phone': MobileOutlined,
  console: ControlOutlined,
  tv: DesktopOutlined,
  'car browser': CarOutlined,
  'smart display': DesktopOutlined,
  camera: CameraOutlined,
  'portable media player': PlaySquareOutlined,
  phablet: MobileOutlined,
  'smart speaker': SoundOutlined,
  wearable: ClockCircleOutlined,
  peripheral: UsbOutlined,
};

// Labels remain beside the icon; hide the decorative graphic from assistive technology.
export const DeviceTypeIcon = ({ value }) => {
  const key = String(value ?? '').toLowerCase();
  const Icon = Object.hasOwn(analyticsIcons, key) ? analyticsIcons[key] : null;
  return Icon
    ? <Icon aria-hidden="true" />
    : <span aria-hidden="true" style={{ display: 'inline-block', width: 16, height: 16, verticalAlign: 'middle' }} />;
};

const deviceTypeIcons = [{
  label: 'mobile',
  icon: MobileOutlined,
}, {
  label: 'tablet',
  icon: TabletOutlined,
}, {
  label: 'desktop',
  icon: DesktopOutlined,
},
];

const DeviceTypeIcons = ({ deviceTypes }) => deviceTypeIcons.filter(d => !deviceTypes?.length || deviceTypes.includes(d.label.toUpperCase())).map(({ label, icon: Icon }) => <Tooltip key={label} title={<FormattedMessage {...globalMessages[label]} />}><Icon style={{ marginRight: '.5em' }} rotate={label === 'tablet' ? 90 : 0} /></Tooltip>);

export default DeviceTypeIcons;
